export interface IMapping {
    sampleFieldKey: string;
    startIndex: number | null;
    endIndex: number | null;
    dataValue?: string;
    sampleKeys?: any[];
}

export interface IScannerFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    isDelimited: boolean;
    delimiter: string;
    mappings: IMapping[];
    isEnabled: boolean;
    scannerContent: string;
    sampleKeys?: any[];
    setPreview(value: string): void;
}

export class ScannerFormData implements IScannerFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    isDelimited: boolean;
    delimiter: string;
    mappings: IMapping[];
    isEnabled: boolean;
    scannerContent: string;

    constructor(
        isEditMode: boolean,
        requestId: string,
        id: string,
        name: string,
        isDelimited: boolean,
        delimiter: string,
        mappings: IMapping[],
        isEnabled: boolean,
        scannerContent: string
    ) {
        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.name = name;
        this.isDelimited = isDelimited;
        this.delimiter = delimiter;
        this.mappings = mappings;
        this.isEnabled = isEnabled;
        this.scannerContent = scannerContent;
    }

    public setPreview(value: string) {
        this.scannerContent = value;
    }
}

const defaultScannerFormData = new ScannerFormData(false, "", "", "", false, "", [], false, "");
export { defaultScannerFormData };
